<template>
  <div class="feedback-content">
    <span class="feedback-content__title">How can we help you?</span>
    <Button
      color="green"
      full
      :invert="currentSelection !== Selections.CHANGE_SOMETHING"
      @click="handleSelection(Selections.CHANGE_SOMETHING)"
      >I want to change something</Button
    >
    <Button
      color="green"
      full
      :invert="currentSelection !== Selections.HAVE_QUESTIONS"
      @click="handleSelection(Selections.HAVE_QUESTIONS)"
      >I have a question</Button
    >
    <Button
      color="green"
      full
      :invert="currentSelection !== Selections.ASK_SOMETHING_ELSE"
      @click="handleSelection(Selections.ASK_SOMETHING_ELSE)"
      >Something else</Button
    >
    <Button color="red" @click="handleNext" :disabled="!currentSelection">Next</Button>
    <span class="feedback-content__cancel" @click="emits('close')">Cancel</span>
  </div>
</template>

<script setup lang="ts">
import { SelectionForStage, Selections, Stages } from './types'
import { ref } from 'vue'
import Button from '@/components/Theme2/Button.vue'

const currentSelection = ref<SelectionForStage<Stages.DEFAULT> | null>(null)
const emits = defineEmits<{
  (e: 'close'): void
  (e: 'go-to-stage', stage: Stages): void
}>()

const handleSelection = (selection: SelectionForStage<Stages.DEFAULT>) => {
  if (currentSelection.value === selection) {
    currentSelection.value = null
    return
  }

  currentSelection.value = selection
}

const handleNext = () => {
  switch (currentSelection.value) {
    case Selections.CHANGE_SOMETHING:
      emits('go-to-stage', Stages.CHANGE_SOMETHING)
      break
    case Selections.HAVE_QUESTIONS:
      emits('go-to-stage', Stages.HAVE_QUESTIONS)
      break
    case Selections.ASK_SOMETHING_ELSE:
      emits('go-to-stage', Stages.ASK_SOMETHING_ELSE)
      break
    default:
      break
  }
}
</script>
